/* Wishlist engine (2026-09-10).
   Storage: localStorage "babygo_wishlist_v1" (items keyed by product handle) + a cookie mirror of the
   handles ("babygo_wl") so Liquid can read the list server-side later. Guests and signed-in customers use
   the same storage for now; syncing to the customer account is the next stage.
   Public API: window.BABYGO_WISHLIST { items(), has(handle), add(item), remove(handle), toggle(item) } */
(function () {
  'use strict';
  var KEY = 'babygo_wishlist_v1', COOKIE = 'babygo_wl';
  var d = document, body = d.body;
  /* testing convenience: ?wishlist=reset forgets the sign-in and the saved items in this browser */
  try {
    if (/[?&]wishlist=reset\b/.test(location.search)) {
      localStorage.removeItem(KEY); localStorage.removeItem('babygo_wishlist_user');
      d.cookie = COOKIE + '=;path=/;max-age=0';
    }
  } catch (e) {}
  var WL_URL = '/pages/wishlist';
  /* "signed in" = a Shopify customer login OR an email captured by the wishlist prompt (Klaviyo) */
  var USER_KEY = 'babygo_wishlist_user';
  var KLAVIYO = { siteId: 'T3r2Jy', list: 'WSrVVd', revision: '2025-10-15' };
  function userEmail() {
    try { var v = localStorage.getItem(USER_KEY); if (v) return v; } catch (e) {}
    var pnl = d.querySelector('[data-wl-panel]'); return (pnl && pnl.getAttribute('data-customer-email')) || '';
  }
  /* ---------- Klaviyo: events + a "Wishlist" profile property, keyed by the signed-in email ----------
     "Added to Wishlist" / "Removed from Wishlist" carry the product so flows can email about it; the
     profile property is the current list so flows can check an item is still saved before sending.
     Guests send nothing; at sign-in the saved items are replayed with their original timestamps. */
  function kPost(path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KLAVIYO.siteId), {
      method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO.revision }, body: JSON.stringify(payload)
    });
  }
  function absUrl(u) { try { return new URL(u, location.origin).href; } catch (e) { return u; } }
  function priceNumber(p) { var n = parseFloat(String(p || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? undefined : n; }
  function kEvent(name, item, when) {
    var email = userEmail(); if (!email) return Promise.resolve();
    var props = { ProductName: item.title, ProductURL: absUrl(item.url), ImageURL: absUrl(item.image), Price: item.price, Handle: item.handle, VariantId: item.variantId, VariantTitle: item.options || '' };
    var attrs = { metric: { data: { type: 'metric', attributes: { name: name } } }, profile: { data: { type: 'profile', attributes: { email: email } } }, properties: props, unique_id: name.replace(/\s+/g, '-').toLowerCase() + ':' + item.handle + ':' + (when || Date.now()) };
    var v = priceNumber(item.price); if (v !== undefined) attrs.value = v;
    if (when) attrs.time = new Date(when).toISOString();
    return kPost('events', { data: { type: 'event', attributes: attrs } }).catch(function () {});
  }
  var syncTimer = null;
  function kSyncProfile(now) {
    var email = userEmail(); if (!email) return;
    clearTimeout(syncTimer);
    var run = function () {
      var items = read().slice(0, 20).map(function (i) { return { name: i.title, handle: i.handle, url: absUrl(i.url), image: absUrl(i.image), price: i.price, variant: i.options || '', added: new Date(i.addedAt || Date.now()).toISOString() }; });
      kPost('profiles', { data: { type: 'profile', attributes: { email: email, properties: { 'Wishlist': items, 'Wishlist Count': read().length, 'Wishlist Updated': new Date().toISOString() } } } }).catch(function () {});
    };
    if (now) run(); else syncTimer = setTimeout(run, 800);
  }
  var signedIn = body.classList.contains('customer-logged-in') || !!userEmail();
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

  /* ---------- storage ---------- */
  function read() {
    try { var s = JSON.parse(localStorage.getItem(KEY) || '{}'); return Array.isArray(s.items) ? s.items : []; } catch (e) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify({ items: items, updated: Date.now() })); } catch (e) {}
    try { d.cookie = COOKIE + '=' + encodeURIComponent(items.map(function (i) { return i.handle; }).join(',')) + ';path=/;max-age=31536000;SameSite=Lax'; } catch (e) {}
    d.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: items } }));
  }
  function w_id() { return window.BABYGO_ID || null; }
  var API = {
    items: read,
    has: function (h) { return read().some(function (i) { return i.handle === h; }); },
    add: function (item) { var items = read().filter(function (i) { return i.handle !== item.handle; }); item.addedAt = Date.now(); items.unshift(item); write(items); return true; },
    remove: function (h) { write(read().filter(function (i) { return i.handle !== h; })); return false; },
    toggle: function (item) { return API.has(item.handle) ? API.remove(item.handle) : API.add(item); }
  };
  window.BABYGO_WISHLIST = API;
  d.addEventListener('wishlist:change', function () { paint(); }); /* any change (clicks, page scripts, other code) repaints hearts + dot */

  /* ---------- item from a toggle button (product page reads the selected variant) ---------- */
  function itemFrom(btn) {
    var item = {
      handle: btn.getAttribute('data-wl-handle'),
      title: btn.getAttribute('data-wl-title'),
      url: btn.getAttribute('data-wl-url'),
      image: btn.getAttribute('data-wl-image'),
      price: btn.getAttribute('data-wl-price'),
      variantId: btn.getAttribute('data-wl-variant'),
      options: btn.getAttribute('data-wl-options') || ''
    };
    if (btn.hasAttribute('data-wl-page')) {
      var sel = d.querySelector('form[data-type="add-to-cart-form"] [name="id"]:not([disabled]), select[name="id"]');
      var id = sel ? sel.value : (new URLSearchParams(location.search).get('variant') || item.variantId);
      var json = d.querySelector('script[data-wl-variants="' + item.handle + '"]');
      if (json) {
        try {
          var map = JSON.parse(json.textContent), v = map[id];
          if (v) {
            item.variantId = id; item.price = v.price; item.image = v.image || item.image;
            item.options = v.options.map(function (o) { return o.name + ': ' + o.value; }).join(' · ');
            item.optionsList = v.options;
          }
        } catch (e) {}
      }
    }
    return item;
  }

  /* ---------- state painting ---------- */
  function paint() {
    var items = read(), has = {};
    items.forEach(function (i) { has[i.handle] = true; });
    d.querySelectorAll('[data-wl-toggle]').forEach(function (b) {
      var on = !!has[b.getAttribute('data-wl-handle')];
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    d.querySelectorAll('[data-wl-dot]').forEach(function (dot) { dot.hidden = items.length === 0; var h = dot.closest('[data-wl-header]'); if (h) h.classList.toggle('has-dot', items.length > 0); });
    /* the header heart's Liquid href is Shopify's login for guests; an email sign-in makes it the wishlist page */
    if (signedIn) d.querySelectorAll('[data-wl-header]').forEach(function (h) { h.href = WL_URL; h.setAttribute('data-signed-in', 'true'); });
  }
  function popDot() {
    d.querySelectorAll('[data-wl-dot]').forEach(function (dot) {
      dot.hidden = false; dot.classList.remove('is-pop'); void dot.offsetWidth; dot.classList.add('is-pop');
    });
  }

  /* ---------- panel ---------- */
  var panel = d.querySelector('[data-wl-panel]'), timer = null;
  function view(name) {
    panel.querySelectorAll('[data-wl-view]').forEach(function (v) { v.hidden = v.getAttribute('data-wl-view') !== name; });
  }
  function open(name) {
    if (!panel) return;
    clearTimeout(timer);
    view(name);
    if (name === 'signup') {
      var v = panel.querySelector('[data-wl-view="signup"]'), waiting = read().length > 0, k = waiting ? 'waiting' : 'empty';
      v.classList.toggle('is-waiting', waiting); v.classList.toggle('is-empty', !waiting);
      v.querySelector('[data-wl-signup-heading]').textContent = v.getAttribute('data-' + k + '-heading');
      v.querySelector('[data-wl-signup-copy]').textContent = v.getAttribute('data-' + k + '-copy');
      if (w_id()) w_id().decorate(v.querySelector('#wl-email')); /* known from elsewhere → pre-filled, one-tap Sign in */
    }
    panel.hidden = false;
    void panel.offsetWidth;
    panel.classList.add('is-open');
    d.querySelectorAll('[data-wl-header]').forEach(function (h) { h.classList.add('is-open'); });
    if (name === 'added') timer = setTimeout(close, 6000);
  }
  function close() {
    if (!panel || !panel.classList.contains('is-open')) return;
    clearTimeout(timer);
    panel.classList.remove('is-open');
    d.querySelectorAll('[data-wl-header]').forEach(function (h) { h.classList.remove('is-open'); });
    setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 350);
  }
  function showItem(item, added) {
    var q = function (s) { return panel.querySelector(s); };
    q('[data-wl-heading]').textContent = added ? 'Added to Wishlist' : 'Removed from Wishlist';
    q('[data-wl-item-img]').src = item.image || '';
    q('[data-wl-item-img]').alt = item.title || '';
    q('[data-wl-item-title]').textContent = item.title || '';
    panel.querySelectorAll('[data-wl-item-link]').forEach(function (a) { a.href = item.url || '#'; });
    var meta = q('[data-wl-item-options]'); meta.innerHTML = '';
    (item.optionsList || (item.options ? [{ name: '', value: item.options }] : [])).forEach(function (o) {
      var line = d.createElement('div'); line.textContent = o.name && o.name.toLowerCase() !== 'title' ? o.name + ': ' + o.value : o.value; meta.appendChild(line);
    });
    q('[data-wl-item-price]').textContent = item.price || '';
    open('added');
  }
  if (panel) {
    panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
    panel.addEventListener('mouseleave', function () { if (!panel.querySelector('[data-wl-view="added"]').hidden) timer = setTimeout(close, 3000); });
  }

  /* ---------- clicks ---------- */
  d.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-wl-toggle]'))) {
      e.preventDefault(); e.stopPropagation();
      var item = itemFrom(t), wasEmpty = read().length === 0;
      var nowSaved = API.toggle(item);
      t.classList.remove('is-bump'); void t.offsetWidth; t.classList.add('is-bump');
      paint();
      kEvent(nowSaved ? 'Added to Wishlist' : 'Removed from Wishlist', item); kSyncProfile();
      if (nowSaved && wasEmpty) popDot();
      if (nowSaved) showItem(item, true); else close(); /* removing is silent — no notification */
      return;
    }
    if ((t = e.target.closest('[data-wl-header]'))) {
      if (signedIn) return; /* normal link to the wishlist page */
      e.preventDefault();
      if (panel && panel.classList.contains('is-open') && !panel.querySelector('[data-wl-view="signup"]').hidden) { close(); return; }
      open('signup');
      return;
    }
    if ((t = e.target.closest('[data-wl-view-all]'))) {
      if (signedIn) return; /* navigates to the wishlist page */
      e.preventDefault();
      open('signup');
      return;
    }
    if (e.target.closest('[data-wl-close]')) { e.preventDefault(); close(); return; }
    /* click anywhere outside the box closes it (desktop has no scrim; on mobile the scrim already does this) */
    if (panel && panel.classList.contains('is-open') && !e.target.closest('.wl-panel__box')) close();
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  /* sign in: a real email → Klaviyo list (same client endpoint + payload shape as Follow Your Bump) → wishlist page */
  d.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-wl-email-form]');
    if (!f) return;
    e.preventDefault();
    var input = f.querySelector('input[type="email"]'), btn = f.querySelector('[data-wl-submit]'), err = panel.querySelector('[data-wl-error]');
    var email = (input.value || '').trim().toLowerCase();
    err.hidden = true;
    if (!EMAIL_RE.test(email)) { input.classList.add('is-invalid'); input.focus(); err.textContent = 'Please enter a valid email address.'; err.hidden = false; return; }
    input.classList.remove('is-invalid');
    btn.disabled = true; btn.classList.add('is-loading');
    var payload = { data: { type: 'subscription', attributes: { custom_source: 'Wishlist', profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: KLAVIYO.list } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO.siteId), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO.revision }, body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok && res.status !== 409) throw new Error('klaviyo ' + res.status);
      try { localStorage.setItem(USER_KEY, email); } catch (e2) {}
      if (w_id()) w_id().set(email, 'wishlist');
      signedIn = true; paint();
      /* catch-up: everything hearted as a guest, with its original time, then the current-list property */
      var items = read();
      items.forEach(function (it) { kEvent('Added to Wishlist', it, it.addedAt); });
      kSyncProfile(true);
      view('success'); panel.classList.remove('is-slid'); void panel.offsetWidth; panel.classList.add('is-slid');
      setTimeout(function () { location.href = WL_URL; }, 1600);
    }).catch(function () {
      btn.disabled = false; btn.classList.remove('is-loading');
      err.textContent = 'Something went wrong. Please try again.'; err.hidden = false;
    });
  });

  /* products injected later (predictive search results, quick view, infinite scroll) */
  new MutationObserver(function () { paint(); }).observe(d.documentElement, { childList: true, subtree: true });
  paint();
})();
